import { useQuery } from "@tanstack/react-query";
import { getAllAirlines } from "../../api/apiAirlines";

const QUERY_KEY = ["airlines"];

const useGetAirlines = (page = 1, perPage = 15, filters = {}) => {
  const {
    data,
    isLoading,
    isError,
    error,
    isFetching
  } = useQuery({
    queryKey: [...QUERY_KEY, page, perPage, filters],
    queryFn: () => getAllAirlines(page, perPage, filters),
    keepPreviousData: true,
  });

  return {
    isLoading,
    isFetching,
    error: isError ? error : null,
    airlines: data?.data?.items || data?.data || [],
    meta: data?.meta || data?.data?.meta || null,
  };
};

export default useGetAirlines;
